import { EditorProps } from "@monaco-editor/react";

export const DEFAULT_MONACO_OPTIONS: EditorProps["options"] = {
  renderLineHighlight: "none",
  minimap: { enabled: false },
  wordWrap: "on",
  fontFamily: "var(--global-font-family-monospace)",
  lineNumbers: "on",
  lineDecorationsWidth: 0,
  contextmenu: false,
  scrollBeyondLastLine: false,
  hideCursorInOverviewRuler: true,
  overviewRulerBorder: false,
  overviewRulerLanes: 1,
  scrollbar: {
    horizontal: "hidden",
    verticalScrollbarSize: 5,
  },
  padding: { top: 12 },
  wrappingIndent: "same",
  selectionHighlight: false,
  occurrencesHighlight: false,
};
